import SearchForm from "@/components/feature/SearchForm";
import { navSites } from "@/mocks/navSites";
import { categories } from "@/mocks/navCategories";

const stats = [
  { value: `${navSites.length}`, label: "精选网址", icon: "ri-links-line" },
  { value: `${categories.length}`, label: "一级分类", icon: "ri-folder-3-line" },
  { value: "30+", label: "二级领域", icon: "ri-bar-chart-box-line" },
  { value: "每日", label: "人工复核", icon: "ri-shield-check-line" },
];

export default function Banner() {
  return (
    <section className="relative w-full overflow-hidden bg-primary-900">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20deep%20blue%20gradient%20background%20with%20soft%20glowing%20network%20lines%20and%20floating%20rounded%20cards%2C%20subtle%20orange%20light%20accents%2C%20dark%20moody%20atmosphere%20with%20strong%20contrast%20for%20white%20text%2C%20minimal%20modern%20technology%20illustration&width=1920&height=900&seq=51nav-hero-bg-01&orientation=landscape"
          alt="51网址导航背景，深蓝渐变与网络连线构成的抽象视觉"
          title="51网址导航 - 分类齐全的实用网址导航平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-900/80 to-primary-950/90" />
        <div className="absolute inset-0 grid-fade opacity-[0.12]" />
      </div>

      <div className="relative w-full px-4 md:px-6 pt-14 md:pt-20 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs border border-background-50/20 animate-fade-in">
            <i className="ri-flashlight-line text-accent-400" />
            已收录 {navSites.length} 个常用网站 · 持续人工更新
          </span>
          <h2 className="mt-5 font-heading font-extrabold text-3xl md:text-5xl leading-tight text-background-50 tracking-tight animate-fade-up">
            上网，从一个干净的入口开始
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-100/85 leading-7 animate-fade-up" style={{ animationDelay: "80ms" }}>
            生活、购物、娱乐、学习……按分类快速找到你真正需要的网站。无需记忆域名，也不用在搜索结果里反复挑选。
          </p>

          <div className="mt-7 md:mt-9 max-w-2xl mx-auto animate-fade-up" style={{ animationDelay: "140ms" }}>
            <SearchForm />
          </div>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 animate-fade-up" style={{ animationDelay: "220ms" }}>
            {stats.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg bg-background-50/10 border border-background-50/15 text-left"
              >
                <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-background-50/15 text-accent-300">
                  <i className={`${item.icon} text-base`} />
                </span>
                <span className="min-w-0">
                  <span className="block font-heading font-bold text-base md:text-lg text-background-50 leading-tight">
                    {item.value}
                  </span>
                  <span className="block text-[11px] text-background-100/70 whitespace-nowrap">
                    {item.label}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}